<h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
    <span class="dialog-header">Rating and Comments</span>
    <i mat-dialog-close class="fa fa-times model_close cursor-pointer"></i>
</h1>
<div mat-dialog-content class="popup-content">
    <div><span class="title">Title: </span><span class="description">Meta data description</span></div>
    <div class="rating-container">
        <span class="rating-point">Rating:</span>
        <div class="star-rating">
            <span class="star"
            *ngFor="let star of stars; let i = index"
            (click)="rate(i + 1)"
            [ngClass]="{'filled': i < rating,'unfill':i==rating}">
            &#9733;
            </span>
        </div>
    </div>
    <div>
        <span class="title">Comments:</span>
        <div>
            <textarea class="txt-area" [(ngModel)]="comment" tabindex="-1" placeholder="Enter comments here... " autocomplete="off"></textarea>
        </div>
    </div>
</div>
<div mat-dialog-actions class="popup-buttons d-flex justify-content-end">
    <button mat-dialog-close class="custom_btn inverted_btn_base ml-2">Cancel</button>
    <button class="custom_btn primary_btn_base ml-2" (click)="save()">Save</button>
</div>